import { MessageApi } from '../../generated/api';
import configuration from './configuration';

export default new MessageApi(configuration);
